import {
  HTTP_DELETEPROJECT_FETCHING,
  HTTP_DELETEPROJECT_SUCCESS,
  HTTP_DELETEPROJECT_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

//Update Special
export const setStatedeleteProjectToFetching = () => ({
  type: HTTP_DELETEPROJECT_FETCHING,
});

export const setStatedeleteProjectToSuccess = (payload) => ({
  type: HTTP_DELETEPROJECT_SUCCESS,
  payload,
});

export const setStatedeleteProjectToFailed = (payload) => ({
  type: HTTP_DELETEPROJECT_FAILED,
});

export const deleteProjectById = (pid) => {
  return async (dispatch) => {
    dispatch(setStatedeleteProjectToFetching());
    try {
      // const result = await httpClient.put(
      await Axios.delete(`${server.DELETEPROJECT_URL}/${pid}`, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      dispatch(setStatedeleteProjectToSuccess("success"));
    } catch (error) {
      dispatch(setStatedeleteProjectToFailed());
    }
  };
};
